<div #contentDiv class="max-w-lg mx-auto flex flex-col pt-20 min-h-[calc(100vh)]">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-full p-4 text-theme-text">
    <div class="flex items-center space-x-4">
      <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl"
        (onClick)="back()"></app-circle-button>
      <div class="text-lg text-theme-text font-semibold">{{getString("Mitt konto", "upper")}}</div>
    </div>
    <div *ngIf="app" class="space-y-6 pt-4">
      <!-- Profilinformation -->
      <div class="bg-theme-surface2 rounded-lg shadow p-4">
        <table class="w-full border-collapse">
          <!-- Namn -->
          <tr class="border-b">
            <td class="py-3 font-semibold text-sm text-theme-text">{{ getString("Namn") }}</td>
            <td class="py-3 text-sm text-theme-text">{{ app.order.user_cfg.user_name }}</td>
          </tr>
          <!-- E-post -->
          <tr *ngIf="app.order?.user_cfg?.email" class="border-b">
            <td class="py-3 font-semibold text-sm text-theme-text">{{ getString("E-post") }}</td>
            <td class="py-3 text-sm text-theme-text">{{ app.order.user_cfg.email }}</td>
          </tr>
          <!-- Phone -->
          <tr *ngIf="app.order?.user_cfg?.auth_phone" class="border-b">
            <td class="py-3 font-semibold text-sm text-theme-text">{{ getString("Konto") }}</td>
            <td class="py-3 text-sm text-theme-text">{{ app.order.user_cfg.auth_phone }}</td>
          </tr>
          <!-- Messenger-konto -->
          <tr *ngIf="app.order?.user_cfg?.connected_account" class="border-b">
            <td class="py-3 font-semibold text-sm text-theme-text">Messenger-konto</td>
            <td class="py-3 text-sm text-theme-text">Kopplat</td>
          </tr>
<!--          &lt;!&ndash; Kontotyp &ndash;&gt;-->
<!--          <tr *ngIf="accountType" class="border-b">-->
<!--            <td class="py-3 font-semibold text-sm text-theme-text">{{ getString("Kontotyp") }}</td>-->
<!--            <td class="py-3 text-sm text-theme-text">{{ accountType }}/{{ messengerSDKInfoShort }}</td>-->
<!--          </tr>-->
          <!-- SmartTable -->
          <tr *ngIf="smartTable" class="border-b">
            <td class="py-3 font-semibold text-sm text-theme-text">SmartTable&#8482;</td>
            <td class="py-3 text-sm text-theme-text">
              <div *ngIf="!smartTable?.account">Aktivt</div>
              <div *ngIf="smartTable?.account" class="mt-2">
                <span class="font-semibold">{{ getString("Konto:") }}</span>
                {{ smartTable.account }}
              </div>
              <div *ngIf="smartTable?.price_list" class="mt-2">
                <span class="font-semibold">{{ getString("Prislista:") }}</span>
                {{ smartTable.price_list }}
              </div>
              <div class="py-2 px-4">
                <app-plain-button [text]="'Lämna SmartTable&#8482;'" bgColor="bg-theme-surface" font="font-medium" textSize="text-xs" customClass="border" (onClick)="leaveSmartTable()"></app-plain-button>
            </div>
            </td>
          </tr>
          <!-- Konto skapat -->
          <tr class="border-b">
            <td class="py-3 font-semibold text-sm text-theme-text">{{ getString("Konto skapat") }}</td>
            <td class="py-3 text-sm text-theme-text">{{ app.order.user_cfg.user_created_date }}</td>
          </tr>
        </table>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-4">
        <!--
        <div *ngIf="false">
          <button class="w-full py-3"
            (click)="editProfile()">
            REDIGERA PROFIL
          </button>
        </div>
        -->
        <div *ngIf="app.order.user_cfg.user_type !== 'messenger' && !app.order?.user_cfg?.connected_account">
          <div class="env-panel p-4 pt-4 bg-primary rounded" >
            <app-page-button text="Koppla Messenger-konto" icon="fa-brands fa-facebook-messenger" (onClick)="connectMessengerAccount()"></app-page-button>
          </div>
        </div>
        <div *ngIf="showLogout">
          <div class="env-panel px-4 bg-primary rounded" >
            <app-action-button text="Logga ut" (onClick)="logout()"></app-action-button>
        </div>
        <div class="text-center text-xs text-theme-text3 pt-4">
          <a class="underline" href (click)="openGdpr()">Mer om vårt dataskydd och GDPR</a>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading"
      class="fixed top-0 bottom-0 left-0 right-0 bg-theme-surface-80 p-4 pb-safe z-10 flex items-center justify-center">
      <app-loading-spinner size="xl"></app-loading-spinner>
    </div>

  </div>
</div>
